import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

import { Loader, Tabs } from '@thinknet-gmbh/platform-common-ui';
import { PageLayout } from '@thinknet-gmbh/platform-common-ui';

import { useGetOwnData } from 'src/hooks/employees/get-own-data.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { EmployeeDocuments } from './own-data-tabs/employee-documents';
import { PersonalInfoView } from 'src/components/employee/personal-info-view';
import { PaymentAndInsuranceView } from 'src/components/employee/payment-and-insurance/payment-and-insurance-view';
import { PersonalInfoEdit } from './own-data-tabs/personal-info/personal-info-edit';
import { PaymentAndInsuranceEdit } from './own-data-tabs/payment-and-insurance/payment-and-insurance-edit';

import { OWN_DATA_TABS } from './own-data-tabs/own-data.constants';

import { EmployeeDetailsWrapper } from './own-data.styles';
import { WorkingConditions } from './own-data-tabs/working-conditions';

const { TabPane } = Tabs;

const OwnData = () => {
  const { t } = useTranslation(['settings', 'employee']);
  const location = useLocation();

  const [editPage, setEditPage] = useState<string | null>(null);
  const [editData, setEditData] = useState<any>(location.state?.initialData || null);

  const currentCompanyId = useGetCurrentCompanyId();
  const { employee, loading } = useGetOwnData();

  const onCancel = () => {
    setEditPage(null);
    setEditData(null);
  };

  if (loading || !currentCompanyId) {
    return <Loader />;
  }

  return (
    <PageLayout pageTitle={t('employee:labels.ownData')}>
    <EmployeeDetailsWrapper>
      <Tabs onChange={onCancel} defaultActiveKey={location.state?.activeTabKey}>
        <TabPane tab={t('employee:employeePersonalInfo.labels.personalInfo')} key="1">
          {editPage === OWN_DATA_TABS.personalInfo ? (
            <PersonalInfoEdit isOwnData onCancel={onCancel} initialValues={editData} />
          ) : (
            <PersonalInfoView
              employee={employee}
              onClickEdit={() => {
                setEditPage(OWN_DATA_TABS.personalInfo)
                setEditData(employee)
              }}
            />
          )}
        </TabPane>
        <TabPane tab={t('employee:labels.workingConditions')} key="2">
          <WorkingConditions />
        </TabPane>
        <TabPane tab={t('employee:labels.paymentAndInsurance')} key="3">
          {editPage === OWN_DATA_TABS.paymentAndInsurance ? (
            <PaymentAndInsuranceEdit
              onCancel={onCancel}
              initialValues={employee.paymentAndInsurance}
            />
          ) : (
            <PaymentAndInsuranceView
              paymentAndInsurance={{
                ...employee.paymentAndInsurance,
                createdBy: employee.createdBy,
              }}
              healthInsurance={employee?.healthInsurance}
              onClickEdit={() => setEditPage(OWN_DATA_TABS.paymentAndInsurance)}
            />
          )}
        </TabPane>
        <TabPane tab={t('settings:documents.labels.documents')} key="4">
          <EmployeeDocuments employeeId={employee?._id} documentsIds={employee.documentsIds}  />
        </TabPane>
      </Tabs>
    </EmployeeDetailsWrapper>
    </PageLayout>
  );
};

export default OwnData;
